import { render } from "./MandatoryIcon.vue?vue&type=template&id=0df1cf04&scoped=true"
const script = {}

import "./MandatoryIcon.vue?vue&type=style&index=0&id=0df1cf04&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df1cf04"]])

export default __exports__